<template>
  <div class="toast" v-bind:class="{'toast--active': opened}" >{{toastMessage}}</div>
</template>

<script>
  import * as types from '../../store/mutation-types';

  export default {
    props: {
      msg: null,
      time: {
        default: 5,
      },
    },
    data() {
      return {
        toastMessage: null,
      };
    },
    computed: {
      timeout() {
        return this.time * 1000;
      },
      opened() {
        return !!this.msg;
      },
    },
    watch: {
      msg(msg, oldmsg) {
        if (msg) {
          this.toastTimeout = window.setTimeout(() => {
            this.$store.commit(types.HIDE_TOAST);
          }, this.timeout);
        }
        this.toastMessage = msg || oldmsg;

        return msg;
      },
    },
  };
</script>

<style lang="scss">
$mobile-breakpoint: 1023px;

.toast {
  background: #000;
  color: #fff;
  font-size: 14px;
  padding: 0 15px;
  line-height: 48px;
  position: fixed;
  top: 15px;
  right: 15px;
  transition: 1s;
  opacity: 0;
  z-index: 200;
  box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, .86);
  transform: translateY(-100px);

  @media only screen and (max-width: #{$mobile-breakpoint}) {
    display: none;
  }

  &--active {
    opacity: 1;
    transform: translateY(0px)
  }
}
</style>
